import {
    Component
} from '@angular/core';
import {
    ChangeDetectorRef
} from '@angular/core';
import {
    ApperyioHelperService
} from '../../scripts/apperyio/apperyio_helper';
import {
    ApperyioMappingHelperService
} from '../../scripts/apperyio/apperyio_mapping_helper';
import {
    ExportedClass as NeurService
} from '../../scripts/custom/NeurService';
import {
    BOOK_RATIO
} from '../../../app/scripts/custom/NeurConstants';
import {
    HEART_COLORS
} from '../../../app/scripts/custom/NeurConstants';
import {
    $aio_empty_object
} from '../../scripts/interfaces';
import {
    Input
} from '@angular/core';
import {
    Output
} from '@angular/core';
import {
    EventEmitter
} from '@angular/core';
import {
    ViewChild
} from '@angular/core';
@Component({
    templateUrl: 'AlbumItem.html',
    selector: 'component-album-item',
    styleUrls: ['AlbumItem.css', 'AlbumItem.scss']
})
export class AlbumItem {
    public widthForVW: number;
    public heightForVW: number;
    public screenOrientation: any;
    public heart_colors: any;
    public $a: ApperyioHelperService;
    public $v: {
        [name: string]: any
    };
    public aioChangeDetector: ChangeDetectorRef;
    public currentItem: any = null;
    public mappingData: any = {};
    public __getMapping(_currentItem, property, defaultValue, isVariable?, isSelected?) {
        return this.$aio_mappingHelper.getMapping(this.mappingData, _currentItem, property, defaultValue, isVariable, isSelected);
    }
    public __isPropertyInMapping(_currentItem, property) {
        return this.$aio_mappingHelper.isPropertyInMapping(this.mappingData, _currentItem, property);
    }
    public __setMapping(data: any = {}, keyName: string, propName?: string): void {
        const changes = data.detail || {};
        if (propName) {
            this.mappingData = this.$aio_mappingHelper.updateData(this.mappingData, [keyName], changes[propName]);
        } else {
            this.mappingData = this.$aio_mappingHelper.updateData(this.mappingData, [keyName], changes.value);
        }
        this.$aio_changeDetector.detectChanges();
    }
    public __bindedMethods: any = {};
    @Input() public image_src: any;
    @Input() public subtitle: any;
    @Input() public title: any;
    ngOnInit(): any {
        this.screenOrientation = this.neurService.screen_orientation;
        this.set_book_size();
        let self = this;
        this.neurService.getScreenOrientation().subscribe((orientation) => {
            self.screenOrientation = self.neurService.screen_orientation;
            self.set_book_size();
        });
    }
    set_book_size(): any {
        if (!this.screenOrientation || this.screenOrientation.startsWith('portrait')) {
            this.widthForVW = 33.33;
            this.heightForVW = (this.widthForVW / BOOK_RATIO.WIDTH * BOOK_RATIO.HEIGHT);
        } else {
            this.widthForVW = 11.11;
            this.heightForVW = (this.widthForVW / BOOK_RATIO.WIDTH * BOOK_RATIO.HEIGHT);
        }
    }
    constructor(public Apperyio: ApperyioHelperService, private $aio_mappingHelper: ApperyioMappingHelperService, private $aio_changeDetector: ChangeDetectorRef, public neurService: NeurService) {
        this.$a = this.Apperyio;
        this.$v = this.Apperyio.vars;
        this.widthForVW = 33.33;
        this.heightForVW = 53.9;
        this.heart_colors = HEART_COLORS;
        this.aioChangeDetector = this.$aio_changeDetector;
    }
}